import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import QuoteForm from "@/components/quote/QuoteForm";

export default function Contact() {
  return (
    <main className="pt-40 pb-24 px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto" data-testid="contact-page">
      <Reveal>
        <Eyebrow>Contact Fairlume</Eyebrow>
        <h1 className="font-display font-bold uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-tight max-w-3xl">
          Let's Talk About Your Facility
        </h1>
      </Reveal>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 mt-16">
        <div className="lg:col-span-4">
          <Reveal delay={0.1}>
            <p className="text-muted-green text-base leading-relaxed">
              Tell us what you're planning — a single signature hole, a full course, a range,
              or an entire property. A lighting specialist will respond within one business day.
            </p>
            <ul className="mt-10 space-y-6 text-sm">
              <li className="flex gap-4 items-start" data-testid="contact-email">
                <Mail size={17} className="text-[#A7D7A0] mt-0.5" />
                <div>
                  <a href="mailto:fairlumeinfo@gmail.com" className="text-white/85 hover:text-[#A7D7A0] transition-colors">fairlumeinfo@gmail.com</a>
                  <p className="text-white/30 text-xs mt-1">Email us anytime</p>
                </div>
              </li>
              <li className="flex gap-4 items-start" data-testid="contact-phone">
                <Phone size={17} className="text-[#A7D7A0] mt-0.5" />
                <div>
                  <a href="tel:+14809530059" className="text-white/85 hover:text-[#A7D7A0] transition-colors">+1 (480) 953-0059</a>
                  <p className="text-white/30 text-xs mt-1">Call or text</p>
                </div>
              </li>
              <li className="flex gap-4 items-start" data-testid="contact-location">
                <MapPin size={17} className="text-[#A7D7A0] mt-0.5" />
                <div>
                  <p className="text-white/85">Gilbert, Arizona</p>
                  <p className="text-white/30 text-xs mt-1">Serving Arizona &amp; nationwide</p>
                </div>
              </li>
            </ul>
            <div className="mt-12 p-7 bg-card-dark border hairline rounded-md">
              <h3 className="font-display font-semibold text-lg">Project Consultation</h3>
              <p className="mt-3 text-muted-green text-sm leading-relaxed">
                Prefer to talk it through first? Request a consultation and we'll schedule a
                call around your facility and goals.
              </p>
              <Link to="/quote" data-testid="contact-consult-cta" className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#A7D7A0] hover:text-white transition-colors">
                Book a Consultation <ArrowUpRight size={15} />
              </Link>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-8">
          <Reveal delay={0.2}>
            <div className="bg-card-dark border hairline rounded-md p-7 sm:p-10 grain relative">
              <QuoteForm />
            </div>
          </Reveal>
        </div>
      </div>
    </main>
  );
}
